export default __webpack_public_path__ + "static/media/digiwork.ea954b3e.png";